import { render, staticRenderFns } from "./ProductsSkeleton.vue?vue&type=template&id=0a83339f&scoped=true"
import script from "./ProductsSkeleton.vue?vue&type=script&lang=ts"
export * from "./ProductsSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./ProductsSkeleton.vue?vue&type=style&index=0&id=0a83339f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a83339f",
  null
  
)

export default component.exports